import Wl2ButtonCell from "@isceco/widget-library2/basic-elements/List/cell/ButtonCell";


export default class OptionalButtonCell extends Wl2ButtonCell {

  constructor(configuration) {
    super(configuration);
    this.show = configuration.show
  }

  render(i18n, cell, row) {
    return this.show(row) ? super.render(i18n, cell, row) : ''
  }
}
